'use client';

import { TaxInfoText, TaxNote } from '@/components/ui/Tax';
import { getCountryCodeFromChannel } from '@/lib/const';
import { useTranslations } from 'next-intl';
import type { FC, ReactNode } from 'react';
import styles from './TotalAmount.module.scss';
import clsx from 'clsx';

export interface TotalAmountProps {
  amount: string;
  channelSlug?: string;
  countryCode?: string;
  context?: 'cart' | 'order';
  hasShippingAddress?: boolean;
  loading?: boolean;
  loadingElement?: ReactNode;
  className?: string;
}

export const TotalAmount: FC<TotalAmountProps> = ({
  amount,
  channelSlug,
  countryCode: countryCodeProp,
  context = 'cart',
  hasShippingAddress,
  loading = false,
  loadingElement,
  className,
}) => {
  const t = useTranslations('checkout');
  const countryCode = countryCodeProp || getCountryCodeFromChannel(channelSlug);

  return (
    <div className={clsx(className, styles.container)}>
      <span className={styles.label}>{t('cart.total')}</span>
      <span className={styles.value} data-testid="cart-total">
        {loading ? (loadingElement ?? <span className={styles.spinner} />) : amount}
      </span>
      {context === 'cart' ? (
        <TaxNote countryCode={countryCode} context="cart" className={styles.subtitle} />
      ) : (
        <TaxInfoText
          countryCode={countryCode}
          hasShippingAddress={hasShippingAddress}
          className={styles.subtitle}
        />
      )}
    </div>
  );
};
